import styled from 'styled-components';
import { rem } from 'polished';
var StyleOptionsContainer = styled.div.withConfig({
  displayName: "StyleOptionsContainer",
  componentId: "e3tpbz-0"
})(["padding-bottom:", ";padding-top:", ";"], rem(4), rem(4));
export default StyleOptionsContainer;